import constants from "../../../constants"
import { Button, ButtonProps } from "@mui/material"

interface DisplayModeButtonProps extends ButtonProps {
    selected: boolean
  }
  
  const DisplayModeButton: React.FC<DisplayModeButtonProps> = ({ 
    selected, 
    ...props 
  }) => {
    return (
      <Button 
        size="small" 
        variant="outlined"
        sx={{
          marginRight: 2,
          paddingX: '10px',
          backgroundColor: selected 
            ? constants.colors.primary 
            : constants.colors.white,
          color: selected 
            ? constants.colors.white 
            : constants.colors.primary,
          fontWeight: selected ? 600 : 500,
          '&:hover': {
            backgroundColor: selected 
              ? constants.colors.primary 
              : constants.colors.white,
            opacity: selected ? 0.9 : 0.8,
          }
        }}
        {...props}
      />
    )
  }

  export default DisplayModeButton